module.exports = __webpack_public_path__ + "img/gi.gi9aac5ee.svg";